module.exports = __webpack_public_path__ + "img/box1-img-1.6dbf6b80.png";